<!--
  @Description 下发流程弹窗填写
  @Date 2022-02-22
  @Author liushuo
-->
<template>
  <div class="modal-dv">
    <vxe-modal
      v-model="isShow"
      :title="modalTitle"
      size="mini"
      width="40%"
      height="auto"
      @show="showWindows"
      @close="closeWindows"
    >
      <div class="edit-dv">
        <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="实际更新版本" prop="issuedVersion">
                <el-input
                  v-model="form.issuedVersion"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  resize="none"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="gap-dv"></div>
          <el-row :span="20">
            <el-col :span="12">
              <el-form-item label="要求下发日期" prop="requestIssuedDate">
                <el-date-picker
                  v-date
                  v-model="form.requestIssuedDate"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  type="date"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
          <div class="gap-dv"></div>
          <el-row class="company-select-row" :gutter="20">
            <el-col :span="8">
              <el-form-item label="选择下发版本" prop="version">
                <el-select clearable filterable v-model="form.version" size="small" placeholder="请选择">
                  <el-option v-for="i of versionOptions" :key="i + ''" :label="i" :value="i"></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择下发企业" prop="detailListCompany">
                <el-select
                  clearable
                  :multiple="true"
                  filterable
                  v-model="form.detailListCompany"
                  size="small"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="i of companyOptionsFilter"
                    :key="i.name + ''"
                    :label="i.name"
                    :value="i.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button @click="selectAllCompany">全选</el-button>
            </el-col>
          </el-row>
          <div class="gap-dv"></div>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="主题" prop="subject">
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="form.subject"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  resize="none"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="btn-dv">
        <button @click="generateFlow">生成</button>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
/**
 * Methods
 * @clearCheckBox 清空父页面checkBox
 * @refreshSingleForm 刷新父页面的single单据
 */
export default {
  name: 'issueFlowEdit',
  props: {
    parentObj: Object,
    modalTitle: {
      type: String,
      default: '生成下发流程'
    }
  },
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      // 产品类型
      menuArgs: '',
      // 下发类型，默认正常
      issuedType: '正常',
      // 当前操作类型，默认"正常"，可选值 ['正常', '打回', '复制']
      curOperateType: '正常',
      // 下发流程表父节点标识（打回流程时需要传）
      origYKIssuedFlowID: 0,
      form: {},
      rules: {
        issuedVersion: [
          { required: true, message: '请填写实际更新版本', trigger: 'change' },
          {
            min: 1,
            max: 10,
            message: '实际更新版本长度应在 1 到 10 个字符',
            trigger: 'change'
          }
        ],
        requestIssuedDate: [{ required: true, message: '请填写要求下发日期', trigger: 'change' }],
        detailListCompany: [{ required: true, message: '请选择下发企业', trigger: 'change' }]
      },
      // 被勾选上的问题标识
      idList: [],
      // 版本选择
      versionOption: [],
      versionOptions: [],
      // 公司选择框 [{ name:'', value:''}]
      companyOptions: []
    }
  },
  methods: {
    initFormData() {
      this.form = {
        issuedVersion: '',
        requestIssuedDate: '',
        subject: '',
        menuArgs: '',
        // 下发类型：[正常|打回]，默认"正常"
        issuedType: this.issuedType,
        // 下发流程表父节点标识（打回时需标识）
        origYKIssuedFlowID: this.origYKIssuedFlowID,
        // 下发问题ID列表
        detailListCase: [],
        // 下发企业企业名称列表
        detailListCompany: [],
        version: ''
      }
    },
    showWindows() {
      this.initFormData()
      this.bindCompanySelect()
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    // 去重
    filterRepeat(array, prop) {
      let map = new Map()
      array.forEach(item => {
        if (!map.has(item[prop])) {
          map.set(item[prop], item)
        }
        return map.values()
      })
      return [...map.values()]
    },
    // 监听模态框关闭
    closeWindows() {
      // this.$refs['FormRef'].resetFields()
    },
    // 绑定企业（调用反馈系统的接口）
    async bindCompanySelect() {
      this.versionOption = []
      this.companyOptions = []
      const { data: res } = await this.$http.get(`Bugs/BSystemVersion/companys?productionType=${this.menuArgs}`, {
        headers: { bugsManagement: true }
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      let versionList = []
      const companyList = []

      res.data.forEach(company => {
        if (company.code === 'productionVersion') {
          versionList.push(company.value)
        } else {
          companyList.push(company)
        }
      })

      this.versionOptions = versionList
      this.companyOptions = companyList
    },
    // 生成下发流程
    async generateFlow() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      this.setFormData()

      const { data: res } = await this.$http.post('/Common/YKIssuedFlow/both', this.form)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      // 生成新下发流程的单据ID
      const newFormID = res.data
      this.$message.success('生成成功')

      // 若在问题汇总界面生成下发流程，则需要刷新问题汇总的[是否已下发]状态
      if (this.curOperateType === '正常') {
        this.$parent.getListPart(this.idList)
        // this.$parent.getList(true, true)
      }

      // 在保存后清空当前表单输入数据
      this.initFormData()

      // 关闭弹窗
      this.isShow = false

      // 清除问题汇总界面的checkbox选中态
      this.$emit('clearCheckBox')

      this.openPush({
        url: 'YKIssuedFlow',
        id: newFormID,
        title: '下发流程',
        msg: '生成下发成功，是否跳转到对应界面？'
      }).then(res => {
        if (this.curOperateType === '正常' && res) {
          this.$bus.$emit('changeNavWithBus', '下发流程')
        }
        // 若为[打回]或[复制]，则说明当前处于流程下发界面，需要拿生成的新单据刷新[下发流程页面]
        if (this.curOperateType === '打回' || this.curOperateType === '复制') {
          this.$emit('refreshSingleForm', newFormID)
        }
      })
    },
    // 验证
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )

      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    },
    // 下发流程参数赋值
    setFormData() {
      this.form.detailListCase = this.idList
      this.form.menuArgs = this.menuArgs
      this.form = this.removeObjectNull(this.form)
    },
    selectAllCompany() {
      this.form.detailListCompany = []
      this.companyOptionsFilter.forEach(company => {
        this.form.detailListCompany.push(company.value)
      })
    }
  },
  computed: {
    companyOptionsFilter() {
      if (!this.form.version) {
        return this.companyOptions
      } else {
        return this.companyOptions.filter(item => item.code === this.form.version)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@btn-dv-height: 60px;
.modal-dv {
  position: relative;
}

.edit-dv {
  width: 100%;
  height: calc(100% - @btn-dv-height);
  box-sizing: border-box;
  padding: 0 15px;
  margin: 0 auto;
}

.btn-dv {
  width: 100%;
  height: @btn-dv-height;
  .fl;

  > button {
    width: 130px;
    height: 40px;
    background-color: @primary-color;
    color: @text-color;
    outline: none;
    border: none;
    border-radius: 10px;
    transition: @normal-transition;
    font-size: 16px;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }
}

.company-select-row {
  display: flex;
  align-items: flex-end;
}

.gap-dv {
  height: 10px;
}
</style>
